import React from 'react'
import styles from './styles.css'
import Container from 'orionsoft-parts/lib/components/Container'
import Button from 'orionsoft-parts/lib/components/Button'
import StartIcon from 'react-icons/lib/md/arrow-forward'

export default class Prices extends React.Component {
  static propTypes = {}

  render() {
    return (
      <div className={styles.container}>
        <div className={styles.head}>
          <Container>
            <div className="row">
              <div className="col-xs-12 col-sm-6">
                <div className={styles.texts}>
                  <div className={styles.title}>Acepta pagos en criptomonedas</div>
                  <div className={styles.lower}>
                    Orion Pay es la forma más facil de recibir pagos en criptomonedas
                  </div>
                  <div className={styles.button}>
                    <Button to="dashboard" primary>
                      Empezar <StartIcon />
                    </Button>
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-sm-6">
                <div className={styles.demo}>
                  <img src="/demo.png" alt="demo" />
                </div>
              </div>
            </div>
          </Container>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Home/Home/Top/index.js